module.exports = __webpack_public_path__ + "img/logo.cc2ef123.png";